module.exports = __webpack_public_path__ + "img/osago-advantages.5cd456b.webp";